// Lets a list page (Tournaments/Clubs/Players/Locations) tell Header.js
// "my search bar just scrolled out of reach, show a stand-in icon in the
// header" - and hands over what tapping that icon should do (scroll back up
// and focus the real input) without Header needing to know anything about
// the page it's currently showing.
export const compactSearchSubscribers = new Set();

export const publishCompactSearch = (state) => {
    compactSearchSubscribers.forEach(cb => cb(state));
};
